import React from "react";
import { Card, CardContent, Divider, MenuItem, Pagination, Radio, Switch, TextField, Grow, Grid, Autocomplete, Button, FormControlLabel, Checkbox, InputLabel, FormControl, TableCell, TableBody, TableHead, Table, TableRow } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goEditInflow, goToLogin, goToNewIncome } from "../../routes/Coordinator"
import axios from "axios";
import { useEffect } from "react";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AddIcon from '@mui/icons-material/Add';
import { Select as MuiSelect } from "@mui/material";
import OutlinedInput from '@mui/material/OutlinedInput';
import PrintIcon from '@mui/icons-material/Print';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import edit from '../../assets/images/edit.png';
import del from '../../assets/images/delete.png';
import view from '../../assets/images/view.png';
import { SelectPatient } from "../Records/InflowRecord/StyledInflowRecord";
import Select from 'react-select'

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const list = [
  {
    value: "",
    label: "Nenhum",
  },
  {
    value: "doc_number",
    label: "Número do Documento",
  },
  {
    value: "value",
    label: "Valor",
  },
  {
    value: "description",
    label: "Descrição",
  },
];
const margemList = [
  {
    value: "true",
    label: "Com Margem",
  },
  {
    value: "false",
    label: "Sem margem",
  },
];
const printList = [
  {
    value: "pdf",
    label: "Imprimir em PDF",
  },
  {
    value: "xls",
    label: "Imprimir em XLS",
  },
];
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2A858B',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const InflowPage = () => {
  const navigate = useNavigate();
  const [doctors, setDoctors] = useState([])
  const [patients, setPatients] = useState([])
  const [types, setTypes] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [begin_release, setBegin_release] = React.useState(new Date())
  const [end_release, setEnd_release] = React.useState(new Date())
  const [doctor_id, setDoctor_id] = useState("")
  const [patient_id, setPatient_id] = useState("")
  const [type_id, setType_id] = useState("")
  const [formato, setFormato] = useState("")
  const [search_key, setSearchKey] = useState("")
  const [search_value, setSearchValue] = useState("")
  const [rows, setRows] = useState([])
  const [valorTotal, setValorTotal] = useState([])
  const [checkedrelease, setCheckedRelease] = useState(true);
  const [checkedpatientname, setCheckedPatientname] = useState(true);
  const [checkedpatientcpf, setCheckedPatientcpf] = useState(true);
  const [checkedpayername, setCheckedPayername] = useState(true);
  const [checkedpayercpf, setCheckedPayercpf] = useState(true);
  const [checkeddoc_number, setCheckedDoc_number] = useState(true);
  const [checkedoption, setCheckedOption] = useState(true);
  const [checkedtypename, setCheckedTypename] = useState(true);
  const [checkedvalue, setCheckedValue] = useState(true);
  const [checkeddescription, setCheckedDescription] = useState(true);
  const [checkedMargin, setCheckedMargin] = useState(true);
  const urlPatientId = UseQuery().get("patient_id")
  const urlPatientName = UseQuery().get("patient_name")



  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const names = [{
    release: 'Data de Lançamento',
    patientname: 'Paciente',
    patientcpf: 'CPF',
    payername: 'Nome do pagador',
    payercpf: 'CPF do pagador',
    doc_number: 'Número do Documento',
    option: 'Opção',
    typename: 'Tipo',
    value: 'Valor',
    description: 'Descrição'
  }];
  const [personName, setPersonName] = React.useState([]);

  const releaseChange = (e) => {
    if (e.target.checked === true) {
      setCheckedRelease(e.target.checked)
    } else {
      setCheckedRelease(false)
    }
  }
  const patientnameChange = (e) => {
    if (e.target.checked) {
      setCheckedPatientname(true)
    } else {
      setCheckedPatientname(false)
    }

  }
  const patientcpfChange = (e) => {
    if (e.target.checked) {
      setCheckedPatientcpf(true)
    } else {
      setCheckedPatientcpf(false)
    }

  }
  const payernameChange = (e) => {
    if (e.target.checked) {
      setCheckedPayername(true)
    } else {
      setCheckedPayername(false)
    }

  }
  const payercpfChange = (e) => {
    if (e.target.checked) {
      setCheckedPayercpf(true)
    } else {
      setCheckedPayercpf(false)
    }

  }
  const doc_numberChange = (e) => {
    if (e.target.checked) {
      setCheckedDoc_number(true)
    } else {
      setCheckedDoc_number(false)
    }

  }
  const optionChange = (e) => {
    if (e.target.checked) {
      setCheckedOption(true)
    } else {
      setCheckedOption(false)
    }

  }
  const typenameChange = (e) => {
    if (e.target.checked) {
      setCheckedTypename(true)
    } else {
      setCheckedTypename(false)
    }

  }
  const valueChange = (e) => {
    if (e.target.checked) {
      setCheckedValue(true)
    } else {
      setCheckedValue(false)
    }

  }
  const descriptionChange = (e) => {
    if (e.target.checked) {
      setCheckedDescription(true)
    } else {
      setCheckedDescription(false)
    }

  }

  const handleChange = (event, page) => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions?nature=inflow&page=${page}`

    if (begin_release && end_release) {
      url = `${url}&begin_release=${begin_release}&end_release=${end_release}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (patient_id) {
      url = `${url}&patient_id=${patient_id}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };

  const filterType = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/types?nature=inflow`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setTypes(response.data.types)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };
  const SearchPDFUrl = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions.${formato}?doctor_id=${doctor_id}&nature=inflow`

    if (begin_release && end_release) {
      url = `${url}&begin_release=${new Date(begin_release).toLocaleDateString("fr-CA")}&end_release=${new Date(end_release).toLocaleDateString("fr-CA")}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (patient_id) {
      url = `${url}&patient_id=${patient_id}`
    }
    if (search_key && search_value) {
      url = `${url}&${search_key}=${search_value}`
    }
    if (checkedrelease) {
      url = `${url}&columns[]=release`
    }
    if (checkedpatientname) {
      url = `${url}&columns[]=patient_or_provider_name`
    }
    if (checkedpatientcpf) {
      url = `${url}&columns[]=patient_or_provider_cpf_cnpj`
    }
    if (checkedpayername) {
      url = `${url}&columns[]=payer_name`
    }
    if (checkedpayercpf) {
      url = `${url}&columns[]=payer_cpf`
    }
    if (checkeddoc_number) {
      url = `${url}&columns[]=doc_number`
    }
    if (checkedoption) {
      url = `${url}&columns[]=option`
    }
    if (checkedtypename) {
      url = `${url}&columns[]=type_name`
    }
    if (checkedvalue) {
      url = `${url}&columns[]=value`
    }
    if (checkeddescription) {
      url = `${url}&columns[]=description`
    }
    if (checkedMargin) {
      url = `${url}&margin=${checkedMargin}`
    }
    return url
  }
  const Search = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions?page=1&nature=inflow`
    if (!doctor_id) {
      alert('Médico não pode ficar em branco');
      return
    }
    if (begin_release && end_release) {
      url = `${url}&begin_release=${new Date(begin_release).toLocaleDateString("fr-CA")}&end_release=${new Date(end_release).toLocaleDateString("fr-CA")}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (type_id) {
      url = `${url}&type_id=${type_id}`
    }
    if (patient_id) {
      url = `${url}&patient_id=${patient_id}`
    }
    if (search_key && search_value) {
      url = `${url}&${search_key}=${search_value}`
    }
    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
        setValorTotal(response.data.meta.total_value)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const DeleteIncomes = (id) => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}`

    axios.delete(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        alert("Receita deletada com sucesso.")
        Search()
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`

    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setDoctors(response.data.doctors)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Patients = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/patients`

    axios.get(url, {
      params: { all: true },
      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        let responseData = response.data.patients.map((patient) => {
          return { value: patient.id, label: patient.name }
        })
        setPatients(responseData)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  useEffect(() => {

    if (localStorage.getItem("access-token") === null || localStorage.getItem("client") === null || localStorage.getItem("uid") === null) {
      alert(`Para continuar, efetue login ou registre-se.`)
      goToLogin(navigate)
    } else {
      Doctors()
      filterType()
      Patients()
    }
  }, [])
  const DeleteButton = (id) => {
    let resposta = window.confirm("Deseja remover esse registro?")
    if (resposta === true) {
      DeleteIncomes(id)
    }
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent sx={{ paddingBottom: '0 !important' }}>
          <Typography variant="h3" sx={{ mb: 2 }}>Receita</Typography>
          <Divider />

          <CardContent
            sx={{
              padding: "30px",
            }}
          >
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="Data inicial"
                    value={begin_release}
                    onChange={(newValue) => {
                      setBegin_release(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    label="Data final"
                    value={end_release}
                    onChange={(newValue) => {
                      setEnd_release(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  select
                  required
                  id="function"
                  label="Selecione o Médico"
                  onChange={(e) => setDoctor_id(e.target.value)}
                  value={doctor_id}
                  name={"doctor_id"}
                  type={"doctor_id"}
                >
                  {doctors.map((doctor) => (
                    <MenuItem key={doctor.id} value={doctor.id}>
                      {doctor.name}
                    </MenuItem>
                  ))}
                </TextField>
                {/* {doctor_id.length === 0 && <p>Médico obrigatório *</p>} */}
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <FormControl
                  sx={{ width: '100%' }}
                >
                  <SelectPatient>
                    <Select
                      placeholder={"Paciente"}
                      options={patients}
                      defaultValue={urlPatientId ? { value: urlPatientId, label: urlPatientName } : null}
                      onChange={(e) => setPatient_id(e.value)}
                    />
                  </SelectPatient>
                </FormControl>

                {/* <Autocomplete
                  disablePortal
                  placeholder={"Nenhum"}
                  options={patients}
                  onChange={(e, v) => setPatient_id(v?.value)}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Paciente" />}
                /> */}
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  fullWidth
                  select
                  id="function"
                  label="Selecione o Tipo"
                  onChange={(e) => setType_id(e.target.value)}
                  value={type_id}
                  type={"type"}
                >
                  {types.map((type) => (
                    <MenuItem key={type.id} value={type.id}>
                      {type.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  sx={{ position: 'sticky' }}
                  fullWidth
                  select
                  id="function"
                  label="Selecione"
                  value={search_key}
                  onChange={(e) => setSearchKey(e.target.value)}
                >
                  {list.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  value={search_value}
                  noValidate
                  autoComplete="off"
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={6} >
                <Box
                  display={"flex"}
                  justifyContent={"flex-end"}
                  alignItems={"center"}
                  marginTop={1}>
                  <Button
                    onClick={() => Search()}
                    variant="contained"
                    color="primary"
                  >
                    <SearchOutlinedIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Pesquisar
                    </Typography>
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => goToNewIncome(navigate)}
                  >
                    <AddIcon />
                    <Typography
                      sx={{ ml: 1 }}
                    >
                      Cadastrar
                    </Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Relatório</Typography>
          <Divider />
          <CardContent
            sx={{
              padding: "30px",
            }}
          >
            <Grid container rowSpacing={2} columnSpacing={3} display={"flex"} alignItems={"center"}>
              <Grid item xs={12} md={12} lg={3}>
                <FormControl fullWidth sx={{ position: 'sticky' }}>
                  <InputLabel >Colunas</InputLabel>
                  <MuiSelect
                    multiple
                    value={personName}
                    // onChange={handleChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    <MenuItem><FormControlLabel control={<Checkbox onChange={releaseChange} checked={checkedrelease} />} value={"release"} label="Data de Lançamento" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={patientnameChange} checked={checkedpatientname} />} value={"patientname"} label="Paciente" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={patientcpfChange} checked={checkedpatientcpf} />} value={"patientcpf"} label="CPF" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={payernameChange} checked={checkedpayername} />} value={"payername"} label="Nome do pagador" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={payercpfChange} checked={checkedpayercpf} />} value={"payercpf"} label="CPF do pagador" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={doc_numberChange} checked={checkeddoc_number} />} value={"doc_number"} label="Número do Documento" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={optionChange} checked={checkedoption} />} value={"option"} label="Opção" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={typenameChange} checked={checkedtypename} />} value={"typename"} label="Tipo" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={valueChange} checked={checkedvalue} />} value={"value"} label="Valor" /></MenuItem>
                    <MenuItem><FormControlLabel control={<Checkbox onChange={descriptionChange} checked={checkeddescription} />} value={"description"} label="Descrição" /></MenuItem>
                  </MuiSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  sx={{ position: 'sticky' }}
                  fullWidth
                  select
                  id="function"
                  label="Margem"
                  onChange={(e) => setCheckedMargin(e.target.value)}
                >
                  {margemList.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>
                <TextField
                  fullWidth
                  select
                  display={"flex"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  label="Formato de impressão"
                  onChange={(e) => setFormato(e.target.value)}
                  value={formato}
                  type={"formato"}
                  name="formato"
                >
                  {printList.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={12} lg={3}>

                <Button target={'_blank'} href={SearchPDFUrl()} variant="contained" color="success" startIcon={<PrintIcon />} >
                  Imprimir
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </CardContent>
      </Card >
      {rows.length === 0 &&
        <CardContent
          sx={{
            padding: "30px",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Stack >
                <Alert severity="warning">Nenhum registro encontrado!</Alert>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      }
      {rows.length > 0 &&
        <Card variant="outlined">
          <CardContent>
            <Box>
              <Table
                aria-label="simple table"
                sx={{
                  mt: 3,
                }}>
                <TableHead>
                  <TableRow>
                    {checkedrelease && <TableCell className="release">
                      <Typography color="textSecondary" variant="h6">
                        Data de Lançamento
                      </Typography>
                    </TableCell>}
                    {checkedpatientname && <TableCell className="patientname">
                      <Typography color="textSecondary" variant="h6">
                        Paciente
                      </Typography>
                    </TableCell>}
                    {checkedpatientcpf && <TableCell className="patientcpf">
                      <Typography color="textSecondary" variant="h6">
                        CPF
                      </Typography>
                    </TableCell>}
                    {checkedpayername && <TableCell className="payername">
                      <Typography color="textSecondary" variant="h6">
                        Nome do Pagador
                      </Typography>
                    </TableCell>}
                    {checkedpayercpf && <TableCell className="payercpf">
                      <Typography color="textSecondary" variant="h6">
                        CPF do pagador
                      </Typography>
                    </TableCell>}
                    {checkeddoc_number && <TableCell className="doc_number">
                      <Typography color="textSecondary" variant="h6">
                        Número do Documento
                      </Typography>
                    </TableCell>}
                    {checkedoption && <TableCell className="option">
                      <Typography color="textSecondary" variant="h6">
                        Opção
                      </Typography>
                    </TableCell>}
                    {checkedtypename && <TableCell className="typename">
                      <Typography color="textSecondary" variant="h6">
                        Tipo
                      </Typography>
                    </TableCell>}
                    {checkedvalue && <TableCell className="value">
                      <Typography color="textSecondary" variant="h6">
                        Valor
                      </Typography>
                    </TableCell>}
                    {checkeddescription && <TableCell className="description">
                      <Typography color="textSecondary" variant="h6">
                        Descrição
                      </Typography>
                    </TableCell>}
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography color="textSecondary" variant="h6">

                      </Typography>
                    </TableCell>

                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow sx={{ backgroundColor: '#D8D8D8' }}>
                    {checkedrelease && <StyledTableCell></StyledTableCell>}
                    {checkedpatientname && <StyledTableCell></StyledTableCell>}
                    {checkedpatientcpf && <StyledTableCell></StyledTableCell>}
                    {checkedpayername && <StyledTableCell></StyledTableCell>}
                    {checkedpayercpf && <StyledTableCell></StyledTableCell>}
                    {checkeddoc_number && <StyledTableCell></StyledTableCell>}
                    {checkedoption && <StyledTableCell></StyledTableCell>}
                    {checkedtypename && <StyledTableCell></StyledTableCell>}
                    {checkedvalue && <StyledTableCell align="center"><b>{valorTotal.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</b></StyledTableCell>}
                    {checkeddescription && <StyledTableCell></StyledTableCell>}
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </StyledTableRow>
                  {rows.map((row) => (
                    <StyledTableRow key={row.id}>
                      {checkedrelease && <StyledTableCell className="release" align="center">
                        {format(Date.parse(`${row.release} 12:00:00`), 'dd/MM/yyyy')}
                      </StyledTableCell>}
                      {checkedpatientname && <StyledTableCell className="patientname" align="center">
                        {row.patient.name}
                      </StyledTableCell>}
                      {checkedpatientcpf && <StyledTableCell className="patientcpf" align="center">
                        {row.patient.cpf}
                      </StyledTableCell>}
                      {checkedpayername && <StyledTableCell className="payername" align="center">

                        {row.patient.payer?.name}

                      </StyledTableCell>}
                      {checkedpayercpf && <StyledTableCell className="payercpf" align="center">

                        {row.patient.payer?.cpf}

                      </StyledTableCell>}
                      {checkeddoc_number && <StyledTableCell className="doc_number" align="center">
                        {row.doc_number}

                      </StyledTableCell>}
                      {checkedoption && <StyledTableCell className="option" align="center">
                        {row.option}

                      </StyledTableCell>}
                      {checkedtypename && <StyledTableCell className="typename" align="center">
                        {row.type.name}
                      </StyledTableCell>}
                      {checkedvalue && <StyledTableCell className="value" align="center">
                        {row.value.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                      </StyledTableCell>}
                      {checkeddescription && <StyledTableCell className="description" align="center">
                        {row.description}
                      </StyledTableCell>}
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}>
                        <Button sx={{ padding: 0, minWidth: 0 }} href={`${process.env.REACT_APP_BASE_URL}/transactions/${row.id}.pdf`} target="_blank"><img src={view}></img></Button>
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}>
                        <Button sx={{ padding: 0, minWidth: 0 }} onClick={() => goEditInflow(navigate, row.id, row.patient.id, row.patient.name)}><img src={edit}></img></Button>
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={{ width: 2, padding: 0, minWidth: 0 }}>
                        <Button sx={{ padding: 0, minWidth: 0 }} onClick={() => DeleteButton(row.id)}><img src={del}></img></Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <Box
                sx={{
                  marginTop: 5,
                  display: 'flex',
                  justifyContent: "flex-end"
                }}
              >
                <Stack spacing={2}>
                  <Pagination count={totalPages} onChange={handleChange} variant="outlined" color="primary" />
                </Stack>
              </Box>
            </Box>
          </CardContent>
        </Card>
      }
    </Box >
  );
};

export default InflowPage;